import MaintenanceState from '@rio-cloud/rio-uikit/components/states/MaintenanceState';
import { FormattedMessage } from 'react-intl';

export const ServiceInMaintenance = () => {
    return (
        <MaintenanceState
            headline={<FormattedMessage id='intl-msg:ordercom-cloud-frontend.maintenance.headline.label' />}
            message={<FormattedMessage id='intl-msg:ordercom-cloud-frontend.maintenance.message.label' />}
        />
    );
};
